import { render, staticRenderFns } from "./asignacionAEstudios.vue?vue&type=template&id=65049406"
import script from "./asignacionAEstudios.vue?vue&type=script&lang=js"
export * from "./asignacionAEstudios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports